import { render, staticRenderFns } from "./SearchItems.vue?vue&type=template&id=2628ae7a"
import script from "./SearchItems.vue?vue&type=script&lang=js"
export * from "./SearchItems.vue?vue&type=script&lang=js"
import style0 from "./SearchItems.vue?vue&type=style&index=0&id=2628ae7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports